import { useEffect } from "react";
import PropTypes from "prop-types";
/*eslint-disable */
import { removeOthers, getUnique } from "../../utils";
import Select from "../common/Select";
import SearchDropdown from "../SearchDropdown/SearchDropdown";
function EducationSection(props) {
  const {
    handleChange,
    activeTab,
    masterData,
    errorObj = {},
    handleSelectChange = () => { },
    educationSection,
    handleOthers = () => { },
    handleSubjectId = () => { },
    subjectOptions,
  } = props;

  const getOptions = () => {
    const optionData = removeOthers(
      masterData?.MasterData?.subjectdata,
      educationSection?.subject?.subjectName || educationSection?.subject
    );
    handleSubjectId(optionData);
  };

  useEffect(() => {
    if (educationSection?.subject) {
      getOptions();
    }
  }, [educationSection]);

  const getClasses = (classes = "", name = "") => {
    return errorObj[name] ? `errored ${classes}` : classes;
  };

  console.log("educationSection :", educationSection);
  console.log("educationSection?.subject :", educationSection?.subject);

  return (
    <div className="education-card mb-4 position-relative">
      <span className="education-card-label">Education</span>
      <p className="txtSmall mb-2 text-start" style={{ fontSize: '13px', color: '#666666', padding: '0 0 15px 0px', fontFamily: 'Montserrat' }}>Highest degree earned</p>
      
      <div className="form-fields-grid row">
        <div className="col-lg-12 mb-4">
          <div className={`position-relative py-2 ${getClasses("", "qualification")}`}>
            <Select
              options={getUnique(
                masterData?.MasterData?.qualificationdata?.map(
                  (val) => val.qualification
                ) || []
              )}
              name="qualification"
              placeholder="Select Qualification *"
              handleChange={(value) =>
                handleSelectChange(value, "qualification")
              }
              selectedValue={
                educationSection?.qualification?.qualification ||
                educationSection?.qualification
              }
              labelClass=""
              label="Select Qualification *"
              required={activeTab === "professional"}
            />
          </div>
        </div>

        <div className="col-lg-12 mb-4">
          <div className={`position-relative py-2 ${getClasses("", "subject")}`}>
            <Select
              options={getUnique(
                masterData?.MasterData?.subjectdata?.map(
                  (val) => val.subjectName
                ) || []
              )}
              name="subject"
              placeholder="Select Discipline *"
              handleChange={(value) => {
                handleSelectChange(value, "subject");
              }}
              selectedValue={
                educationSection?.subject && educationSection?.subject !== ""
                  ? educationSection?.subject
                  : null
              }
              labelClass=""
              label="Select Discipline *"
              required={activeTab === "professional"}
            />
          </div>
        </div>

        <div className="col-lg-12 mb-4">
          <div className={`position-relative py-2 ${getClasses("", "specialization")}`}>
            <SearchDropdown
              options={subjectOptions}
              disabled={!educationSection?.subject}
              index={"Education"}
              keyName="Education"
              handleOtherOption={handleOthers}
              onChange={handleChange}
              selectedValue={educationSection?.specialization}
              labelClass=""
              name="specialization"
              selected="subject"
              placeholder={
                educationSection?.specialization?.length === 0 ||
                  !educationSection?.specialization
                  ? "Select Subject (include upto 3) *"
                  : educationSection?.specialization?.length > 1
                    ? educationSection?.specialization[0] +
                    " +" +
                    String(educationSection?.specialization.length - 1)
                    : educationSection?.specialization[0]
              }
              label="Select Subject (include upto 3) *"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

EducationSection.propTypes = {
  profileDetails: PropTypes.shape({
    qualification: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.object,
    ]),
    stream: PropTypes.string,
    specialization: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.object,
    ]),
  }),
  handleChange: PropTypes.func,
  activeTab: PropTypes.string,
  masterData: PropTypes.object,
  specializationsData: PropTypes.array,
};

EducationSection.defaultProps = {
  handleChange: () => null,
  profileDetails: {},
  activeTab: "",
  masterData: {},
  specializationsData: [],
};

export default EducationSection;
